// src/api.js
const API_BASE_URL = ''

// Function to get the auth token (replace with your actual implementation)
const getAuthToken = () => {
  // Example: Retrieve token from local storage
  return localStorage.getItem('authToken');
};

const request = async (endpoint, method = 'GET', body = null, params = {}) => {
  const url = new URL(`${API_BASE_URL}${endpoint}`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  const options = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url.toString(), options);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        errorData = { error: `HTTP error! Status: ${response.status}` };
      }
      console.error("API Error Response:", errorData);
      throw new Error(errorData.error || errorData.errors?.join(', ') || `HTTP error ${response.status}`);
    }

    // Handle 204 No Content (for DELETE)
    if (response.status === 204) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`API request failed: ${method} ${endpoint}`, error);
    throw error; // Re-throw the error to be caught by the component
  }
};

// --- Event Specific API Functions ---

export const fetchEvents = (startDate, endDate, includeGoogle = false, includeMicrosoft = false) => {
  const params = {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    // include_google: includeGoogle, // Add if needed
    // include_microsoft: includeMicrosoft // Add if needed
  };
  return request('/events', 'GET', null, params);
};

export const createEvent = (eventData) => {
  // Add sync flags if needed based on UI state
  // const body = { event: eventData, sync_with_google: false };
  const body = { event: eventData };
  return request('/events', 'POST', body);
};

export const updateEvent = (id, eventData, recurrenceAction = null, occurrenceDate = null) => {
  const body = {
    event: eventData,
    // Conditionally add recurrence info if present
    ...(recurrenceAction && { recurrence_action: recurrenceAction }),
    ...(occurrenceDate && { occurrence_date: occurrenceDate.toISOString() })
    // Add sync flags if needed
    // sync_with_google: false
  };
  return request(`/events/${id}`, 'PATCH', body); // Use PATCH for updates
};

export const deleteEvent = (id, recurrenceAction = null, occurrenceDate = null) => {
  const body = {
     // Conditionally add recurrence info if present
    ...(recurrenceAction && { recurrence_action: recurrenceAction }),
    ...(occurrenceDate && { occurrence_date: occurrenceDate.toISOString() })
     // Add sync flags if needed
    // sync_with_google: false
  };
   // DELETE requests might not standardly support bodies.
   // If your backend/Rails expects the body for DELETE, this is fine.
   // Otherwise, you might need to send these as query params or adjust the backend route.
  return request(`/events/${id}`, 'DELETE', body);
};